import { useSelector } from "react-redux";
import FFLogo from "../../../img/FREEFIT_LOGO_new.png";
import { selectPartner } from "../../../store/partnerStore";
import { resolvePartnerSync } from "../../../utils/partner";
import { getPartnerAsset } from "../../theme/partnerAssets";
import "./welcomeLayout.scss";

// Shared shell for the welcome flow: full-bleed gradient, the freefit + partner
// brand row, and the pinned bottom CTA. Screen 2 reuses this as-is.
function WelcomeLayout({ children, ctaLabel, onCta }) {
  // resolvePartnerSync, not the selector alone: this shell is the app's first paint
  // on a fresh entry, before silentLogin has dispatched setPartner, and the store
  // would still read NONE — which would drop the partner mark from the brand row.
  const partner = resolvePartnerSync(useSelector(selectPartner));
  const partnerLogo = getPartnerAsset(partner, "partnerLogoImg");

  return (
    <div className="wlc-shell">
      <header className="wlc-shell-brand">
        <img src={FFLogo} alt="freefit" className="wlc-shell-brand-ff" />
        {partnerLogo && <img src={partnerLogo} alt="" className="wlc-shell-brand-partner" />}
      </header>

      <div className="wlc-shell-body">{children}</div>

      <div className="wlc-shell-cta-bar">
        <button type="button" className="wlc-shell-cta" onClick={onCta}>
          {ctaLabel}
        </button>
      </div>
    </div>
  );
}

export default WelcomeLayout;
